import React from 'react'
import List from '@components/LocalMerchant/Coupons/List'
import Detail from '@components/LocalMerchant/Coupons/Detail'
import HotelDetail from '@components/LocalMerchant/Coupons/HotelDetail'
import Receive from '@components/LocalMerchant/Coupons/Receive'
import JiaMengHeader from '@components/JiaMeng/Header/MarketingCenter'
import { isHotelMerchant } from '@util'

export default {
  path: 'coupons',
  component: JiaMengHeader,
  indexRoute: {
    component: List
  },
  stat: '优惠券/首页',
  childRoutes: [
    {
      path: 'detail(/:id)',
      component: props =>
        isHotelMerchant() ? <HotelDetail {...props} /> : <Detail {...props} />,
      stat: '优惠券/创建优惠券'
    },
    {
      path: 'receive/:id',
      component: Receive,
      stat: '优惠券/领取详情页'
    }
  ]
}
